export const MAIN = '/';

export const AUTH = '/auth';
